import React from 'react';

import { IRouter } from '@routers/interface';

export const routerActionListMember: IRouter = {
  path: '/action/:type/:id/list-member/:grades',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'action.list-member', //translate here for breadcrumb and sidebar
  // permissionCode: PermissionCode.CLUBS_UPDATE,
};
